import type { SectionProvider } from '#content/contexts/section'
import type { ContentPromotionTracking } from '#types/content'
import { SectionContextKey } from '#content/contexts/section'

const getSectionData = (provider?: Pick<SectionProvider, 'section' | 'position' | 'parent'>) => {
  if (!provider) return []

  const { section, position = 0, parent } = provider

  return [...getSectionData(parent), section?.name, position + 1]
}

export default (
  promotion: ContentPromotionTracking | undefined,
  contentName,
  parentPromotionName?: string
) => {
  const { $gtm } = useNuxtApp()
  const { path } = useRoute()

  const elementRef = ref()
  const elementComputed = computed(() => elementRef.value instanceof HTMLElement
    ? elementRef.value
    : elementRef.value?.$el)
  const isVisible = useElementVisibility(elementComputed)
  const { section, position, parent } = inject(SectionContextKey, {} as SectionProvider)

  const pageType = getUrlId(path, 'Product')
    ? 'pdp'
    : getUrlId(path, 'Category')
      ? 'plp'
      : 'page'

  const handlePromotionClick = (suffix?: string) => {
    if (section?.name?.includes('opened-search-view')) {
      $gtm.push('topNav.onClickSearchContent', contentName)
      return
    }

    if (promotion) {
      $gtm.push('promotion.onPromotionClick', {
        creative: promotion.creativeName,
        id: promotion.promotionId,
        name: promotion.promotionName,
        position: typeof suffix === 'string' ? suffix : '',
        ...(parentPromotionName && { parent_promotion: parentPromotionName })
      })
    }
  }

  const handlePromotionImpression = () => {
    if (promotion) {
      $gtm.push('promotion.onPromotionImpressions', {
        creative: promotion.creativeName,
        id: promotion.promotionId,
        name: promotion.promotionName,
        position: [pageType, ...getSectionData({ section, position, parent })].filter(Boolean).join('-'),
        ...(parentPromotionName && { parent_promotion: parentPromotionName })
      })
    }
  }

  if (promotion) watchOnce(isVisible, handlePromotionImpression)

  return {
    elementRef,
    isVisible,
    handlePromotionClick,
    handlePromotionImpression
  }
}
